module.exports = __webpack_public_path__ + "static/media/Festus-font.900de089.TTF";